module.exports = __webpack_public_path__ + "assets/media/evening.74eaa01f.mp3";